// HOVER SECOND IMAGE MOBILE

window.onload = function hoverMobile() {
  const elements = document.querySelectorAll(".product-card__image--secondary");
  elements.forEach((element) => {
    let startY = 0;
    let hasMoved = false;

    // Add touchstart event listener
    element.addEventListener("touchstart", (e) => {
      startY = e.touches[0].clientY;
      hasMoved = false;
      element.previousElementSibling.style.opacity = 0;
      element.style.opacity = 1;
    });

    // Detectar movimiento durante el touch
    element.addEventListener("touchmove", (e) => {
      let currentY = e.touches[0].clientY;
      if (Math.abs(currentY - startY) > 5) { // Umbral de 5px para considerar movimiento
        hasMoved = true;
      }
    });

    element.addEventListener("touchend", (e) => {
      // Remove touch effect
      element.previousElementSibling.style.opacity = 1;
      element.style.opacity = 0;

      // Solo ejecutar el enlace si no hubo desplazamiento
      if (!hasMoved) {
        let parentElement = element.parentElement;
        
        if (parentElement.tagName.toLowerCase() === 'a') {
          e.preventDefault();
          setTimeout(() => {
            parentElement.click();
          }, 50);
        }
      }
    });
  });
};

// HABEAS DATA

document.addEventListener('DOMContentLoaded', () => {

  const TOOLTIP_DURATION = 6000; 
  
  // --- CONFIGURACIÓN DRAWER (APP) ---
  const drawerConfig = {
    containerSelector: '#cart-drawer-app',      
    buttonSelector: '.cd-cart-checkout-button', 
    injectionId: 'habeas-drawer-wrapper'        
  };

  const drawerHtmlTemplate = `
    <div id="${drawerConfig.injectionId}" class="habeas-injection-container">
      <div class="habeas-row">
        <input type="checkbox" id="habeas_checkbox_drawer" class="habeas-checkbox">
        <label for="habeas_checkbox_drawer" class="habeas-label">
          Acepto recibir comunicaciones de Wild & Pacific. Al hacer clic y proporcionarnos tus datos, aceptas los términos de nuestra 
          <a href="/pages/politica-de-privacidad-y-datos-personales" target="_blank" style="text-decoration: underline; color: inherit;">
            Política de Privacidad y Términos y Condiciones.
          </a>.
        </label>
      </div>
    </div>
  `;

  // --- LÓGICA DRAWER ---
  async function saveAttributesAndCheckout() {
    try {
      await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ attributes: { 'Habeas Data': 'TRUE' } })
      });
      window.location.href = '/checkout';
    } catch (error) {
      console.error(error);
      window.location.href = '/checkout';
    }
  }

  function initDrawerLogic() {
    const checkoutBtn = document.querySelector(drawerConfig.buttonSelector);
    if (!checkoutBtn || document.getElementById(drawerConfig.injectionId)) return;

    // Inyectar HTML
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = drawerHtmlTemplate;
    const wrapper = tempDiv.firstElementChild;
    checkoutBtn.parentNode.insertBefore(wrapper, checkoutBtn);

    const checkbox = document.getElementById('habeas_checkbox_drawer');

    // Interceptar Click
    checkoutBtn.addEventListener('click', function(e) {
      if (!checkbox.checked) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        triggerErrorVisuals(wrapper, "⚠️ Debes aceptar los términos");
        return false;
      } else {
        e.preventDefault(); 
        checkoutBtn.innerText = 'Procesando...';
        checkoutBtn.style.opacity = '0.7';
        saveAttributesAndCheckout();
      }
    }, true);
  }

  // --- CONFIGURACIÓN MAIN CART ---
  const pageConfig = {
    formSelector: 'form#cart-form',           
    checkboxSelector: '#cart-page-terms',     
    wrapperSelector: '.habeas-data-container' 
  };

  // --- LÓGICA MAIN CART ---
  function initCartPageLogic() {
    const form = document.querySelector(pageConfig.formSelector);
    if (!form) return;

    const checkbox = form.querySelector(pageConfig.checkboxSelector);
    const wrapper = form.querySelector(pageConfig.wrapperSelector);
    const checkoutButtons = form.querySelectorAll('[name="checkout"], [type="submit"]');

    if (!checkbox) return;

    // Actualizar estado visual
    const updateButtonVisuals = () => {
      const isChecked = checkbox.checked;
      
      // Botones Checkout
      checkoutButtons.forEach(btn => {
        btn.style.opacity = isChecked ? '1' : '0.6';
        btn.style.cursor = isChecked ? 'pointer' : 'default';
      });

      // Botones Dinámicos (PayPal/GooglePay)
      const dynamicButtons = form.querySelector('.additional-checkout-buttons');
      if (dynamicButtons) {
        isChecked ? dynamicButtons.classList.add('is-active') : dynamicButtons.classList.remove('is-active');
      }
      
      // Limpiar errores
      if (isChecked && wrapper) {
        wrapper.classList.remove('shake-error');
        const tooltip = wrapper.querySelector('.habeas-tooltip');
        if (tooltip) tooltip.classList.remove('is-visible');
      }
    };

    // Validar al Click
    const validatePageCheckout = (e) => {
      if (!checkbox.checked) {
        e.preventDefault(); 
        triggerErrorVisuals(wrapper, "⚠️ Debes aceptar los términos");
      }
    };

    // Listeners
    checkbox.removeEventListener('change', updateButtonVisuals);
    checkbox.addEventListener('change', updateButtonVisuals);

    checkoutButtons.forEach(btn => {
      btn.removeEventListener('click', validatePageCheckout);
      btn.addEventListener('click', validatePageCheckout);
    });

    updateButtonVisuals();
  }

  // --- UTILIDADES VISUALES (SHAKE & TOOLTIP) ---
  function triggerErrorVisuals(wrapperElement, message) {
    if (!wrapperElement) return;

    // Asegurar posicionamiento
    wrapperElement.style.position = 'relative'; 
    wrapperElement.style.overflow = 'visible'; 
    
    // 1. Animación Shake (Reinicio suave)
    wrapperElement.classList.remove('shake-error');
    setTimeout(() => {
      wrapperElement.classList.add('shake-error');
    }, 50);
    
    // 2. Crear Tooltip si no existe
    let tooltip = wrapperElement.querySelector('.habeas-tooltip');
    if (!tooltip) {
      tooltip = document.createElement('div');
      tooltip.className = 'habeas-tooltip';
      tooltip.innerText = message;
      wrapperElement.appendChild(tooltip);
    }
    tooltip.innerText = message;

    // Mostrar
    requestAnimationFrame(() => {
      tooltip.classList.add('is-visible');
    });

    // 3. Timer para ocultar
    if (wrapperElement.hideTooltipTimer) {
      clearTimeout(wrapperElement.hideTooltipTimer);
    }

    wrapperElement.hideTooltipTimer = setTimeout(() => {
      if (tooltip) tooltip.classList.remove('is-visible');
      wrapperElement.hideTooltipTimer = null;
    }, TOOLTIP_DURATION);
  }

  // --- EJECUCIÓN E INICIALIZACIÓN ---
  const runLogic = () => {
      initDrawerLogic();
      initCartPageLogic();
  };

  runLogic();

  // Observer para cambios AJAX
  const observer = new MutationObserver(() => runLogic());
  observer.observe(document.body, { childList: true, subtree: true });
  
  // Soporte Safari Cache (Botón atrás)
  window.addEventListener('pageshow', (event) => {
    if (event.persisted) runLogic();
  });

});